import script from "./Sanchan1_hongshu.vue?vue&type=script&setup=true&lang=js"
export * from "./Sanchan1_hongshu.vue?vue&type=script&setup=true&lang=js"

import "./Sanchan1_hongshu.vue?vue&type=style&index=0&id=39ba145f&lang=less&scoped=true"
script.__scopeId = "data-v-39ba145f"

export default script